/**
 * @class
 * @classdesc Model for Whitelist on DB
 * * */
export default class Whitelist {
  /**
   *Constructor - sets a model for whitelist Data according to DB
   * @param {String} id
   * @param {String} name
   * @param {String} description
   * @param {String} validInType
   * @param {String} region
   * @param {Array.<Place>} places
   * @param {Array} zones
   * @param {String} validFrom
   * @param {String} validTo
   * @param {String} appRegistrationCode
   * @param {String} notificationEmails
   * @param {Boolean} autoApprove
   * @param {String} approvalMessage
   * @param {Array.<WhitelistUser>} users
   * @param {String} publicRegistrationLinkUuid
   * @param {Boolean} isPublicRegistrationLinkEnabled
   * @param {Boolean} startSessionsWithLPR
   * @param {String} registrationOpenUntil
   * @param {Boolean} chargeForSessions // By default the value of "chargeForSession" is true and can be modified directly in DB
   * @param {String} app
   * @param {String} appId
   * @param {Array.<PromoCode>} promoCodes
   * @param {String} lprActivities
   * @param {String} availabilityTableId
   * @param {String} availabilityTable
   * @param {String} discountPlanId
   * @param {String} discountPlan
   * @param {String} managers
   * @param {String} dynamicSessionsEnabled
   * @param {String} registrationRequestReceivedMessage
   * @param {String} discountPlan
   */

  #WhitelistObject = {}

  constructor(
    id,
    name,
    description,
    validInType,
    region,
    places,
    zones,
    validFrom,
    validTo,
    appRegistrationCode,
    notificationEmails,
    autoApprove,
    approvalMessage,
    users,
    publicRegistrationLinkUuid,
    isPublicRegistrationLinkEnabled,
    startSessionsWithLPR,
    registrationOpenUntil,
    chargeForSessions,
    appId,
    registrationRequestReceivedMessage,
    availabilityTable,
    discountPlan,
    managers
  ) {
    this.#WhitelistObject.Id = id || 0
    this.#WhitelistObject.Name = name || ''
    this.#WhitelistObject.Description = description || ''
    this.#WhitelistObject.ValidInType = validInType || 'PLACES'
    this.#WhitelistObject.Region = region || ''
    this.#WhitelistObject.Places = places || []
    this.#WhitelistObject.Zones = zones || []
    this.#WhitelistObject.ValidFrom = validFrom || this.getValidFrom()
    this.#WhitelistObject.ValidTo = validTo || this.getValidTo()
    this.#WhitelistObject.AppRegistrationCode = appRegistrationCode || ''
    this.#WhitelistObject.NotificationEmails = notificationEmails || ''
    this.#WhitelistObject.AutoApprove = autoApprove || false
    this.#WhitelistObject.ApprovalMessage = approvalMessage || ''
    this.#WhitelistObject.Users = users || []
    this.#WhitelistObject.PublicRegistrationLinkUuid =
      publicRegistrationLinkUuid || ''
    this.#WhitelistObject.IsPublicRegistrationLinkEnabled =
      isPublicRegistrationLinkEnabled || false
    this.#WhitelistObject.StartSessionsWithLPR = startSessionsWithLPR || false
    this.#WhitelistObject.RegistrationOpenUntil = this.getRegistrationOpenUntil()
    this.#WhitelistObject.ChargeForSessions = chargeForSessions || false
    this.#WhitelistObject.AppId = appId || 1
    this.#WhitelistObject.RegistrationRequestReceivedMessage =
      registrationRequestReceivedMessage ||
      'Your registration request has been received. You will receive a confirmation email when your registration is confirmed.'
    this.#WhitelistObject.AvailabilityTable = availabilityTable || {
      ValidFrom: '0001-01-01T00:00:00Z',
      ValidTo: '0001-01-01T00:00:00Z',
      MondayT1: 0,
      MondayT2: 0,
      MondayT3: 0,
      Monday12Spots: 0,
      Monday12Price: 0,
      Monday23Spots: 0,
      Monday23Price: 0,
      Monday31Spots: 0,
      Monday31Price: 0,
      Monday12MinCost: 0,
      Monday12MaxCost: 0,
      Monday23MinCost: 0,
      Monday23MaxCost: 0,
      Monday31MinCost: 0,
      Monday31MaxCost: 0,
      Monday12DiscountPercent: 0,
      Monday23DiscountPercent: 0,
      Monday31DiscountPercent: 0,
      TuesdayT1: 0,
      TuesdayT2: 0,
      TuesdayT3: 0,
      Tuesday12Spots: 0,
      Tuesday12Price: 0,
      Tuesday23Spots: 0,
      Tuesday23Price: 0,
      Tuesday31Spots: 0,
      Tuesday31Price: 0,
      Tuesday12MinCost: 0,
      Tuesday12MaxCost: 0,
      Tuesday23MinCost: 0,
      Tuesday23MaxCost: 0,
      Tuesday31MinCost: 0,
      Tuesday31MaxCost: 0,
      Tuesday12DiscountPercent: 0,
      Tuesday23DiscountPercent: 0,
      Tuesday31DiscountPercent: 0,
      WednesdayT1: 0,
      WednesdayT2: 0,
      WednesdayT3: 0,
      Wednesday12Spots: 0,
      Wednesday12Price: 0,
      Wednesday23Spots: 0,
      Wednesday23Price: 0,
      Wednesday31Spots: 0,
      Wednesday31Price: 0,
      Wednesday12MinCost: 0,
      Wednesday12MaxCost: 0,
      Wednesday23MinCost: 0,
      Wednesday23MaxCost: 0,
      Wednesday31MinCost: 0,
      Wednesday31MaxCost: 0,
      Wednesday12DiscountPercent: 0,
      Wednesday23DiscountPercent: 0,
      Wednesday31DiscountPercent: 0,
      ThursdayT1: 0,
      ThursdayT2: 0,
      ThursdayT3: 0,
      Thursday12Spots: 0,
      Thursday12Price: 0,
      Thursday23Spots: 0,
      Thursday23Price: 0,
      Thursday31Spots: 0,
      Thursday31Price: 0,
      Thursday12MinCost: 0,
      Thursday12MaxCost: 0,
      Thursday23MinCost: 0,
      Thursday23MaxCost: 0,
      Thursday31MinCost: 0,
      Thursday31MaxCost: 0,
      Thursday12DiscountPercent: 0,
      Thursday23DiscountPercent: 0,
      Thursday31DiscountPercent: 0,
      FridayT1: 0,
      FridayT2: 0,
      FridayT3: 0,
      Friday12Spots: 0,
      Friday12Price: 0,
      Friday23Spots: 0,
      Friday23Price: 0,
      Friday31Spots: 0,
      Friday31Price: 0,
      Friday12MinCost: 0,
      Friday12MaxCost: 0,
      Friday23MinCost: 0,
      Friday23MaxCost: 0,
      Friday31MinCost: 0,
      Friday31MaxCost: 0,
      Friday12DiscountPercent: 0,
      Friday23DiscountPercent: 0,
      Friday31DiscountPercent: 0,
      SaturdayT1: 0,
      SaturdayT2: 0,
      SaturdayT3: 0,
      Saturday12Spots: 0,
      Saturday12Price: 0,
      Saturday23Spots: 0,
      Saturday23Price: 0,
      Saturday31Spots: 0,
      Saturday31Price: 0,
      Saturday12MinCost: 0,
      Saturday12MaxCost: 0,
      Saturday23MinCost: 0,
      Saturday23MaxCost: 0,
      Saturday31MinCost: 0,
      Saturday31MaxCost: 0,
      Saturday12DiscountPercent: 0,
      Saturday23DiscountPercent: 0,
      Saturday31DiscountPercent: 0,
      SundayT1: 0,
      SundayT2: 0,
      SundayT3: 0,
      Sunday12Spots: 0,
      Sunday12Price: 0,
      Sunday23Spots: 0,
      Sunday23Price: 0,
      Sunday31Spots: 0,
      Sunday31Price: 0,
      Sunday12MinCost: 0,
      Sunday12MaxCost: 0,
      Sunday23MinCost: 0,
      Sunday23MaxCost: 0,
      Sunday31MinCost: 0,
      Sunday31MaxCost: 0,
      Sunday12DiscountPercent: 0,
      Sunday23DiscountPercent: 0,
      Sunday31DiscountPercent: 0,
      CreatedAt: '2017-08-17T11:44:50Z',
      UpdatedAt: '2020-09-23T14:00:02Z',
      MondayFrom: 0,
      MondayTo: 0,
      TuesdayFrom: 0,
      TuesdayTo: 0,
      WednesdayFrom: 0,
      WednesdayTo: 0,
      ThursdayFrom: 0,
      ThursdayTo: 0,
      FridayFrom: 0,
      FridayTo: 0,
      SaturdayFrom: 0,
      SaturdayTo: 0,
      SundayFrom: 0,
      SundayTo: 0,
      MondayFromV2: 0,
      MondayToV2: 0,
      TuesdayFromV2: 0,
      TuesdayToV2: 0,
      WednesdayFromV2: 0,
      WednesdayToV2: 0,
      ThursdayFromV2: 0,
      ThursdayToV2: 0,
      FridayFromV2: 0,
      FridayToV2: 0,
      SaturdayFromV2: 0,
      SaturdayToV2: 0,
      SundayFromV2: 0,
      SundayToV2: 0,
      UseSundayForHolidays: false
    }
    this.#WhitelistObject.DiscountPlan = discountPlan || {
      Limit24h: 0
    }
    this.#WhitelistObject.Managers = managers || []
  }

  getValidFrom() {
    if (!this.validFrom) {
      return null
    }
    return this.validFrom
  }

  getValidTo() {
    if (!this.validTo) {
      return null
    }
    return this.validTo
  }

  getRegistrationOpenUntil() {
    if (!this.registrationOpenUntil) {
      return null
    }
    return this.registrationOpenUntil
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#WhitelistObject
  }
}
